import { NavLink } from 'react-router-dom';
import { House, Package, StackSimple, MapPin, Bell, ListChecks, ChartBar, Broom, ClockCounterClockwise, UsersThree, ChartLine } from '@phosphor-icons/react';

export default function Sidebar({ user }) {
  // Staff (picker/stocker) only see the day-to-day floor tools.
  // Admin sees everything including Users. Manager sees everything except Users.
  const links = [
    { to: '/', icon: House, label: 'Dashboard', roles: ['admin', 'manager', 'picker', 'stocker'] },
    { to: '/putaway', icon: StackSimple, label: 'Put Away', roles: ['admin', 'manager', 'stocker', 'picker'] },
    { to: '/picking', icon: Package, label: 'Picking', roles: ['admin', 'manager', 'picker', 'stocker'] },
    { to: '/tasks', icon: ListChecks, label: 'All Tasks', roles: ['admin', 'manager'] },
    { to: '/picking-history', icon: ClockCounterClockwise, label: 'Picking History', roles: ['admin', 'manager'] },
    { to: '/housekeeping', icon: Broom, label: 'Housekeeping', roles: ['admin', 'manager', 'stocker', 'picker'] },
    { to: '/capacity', icon: ChartBar, label: 'Capacity', roles: ['admin', 'manager'] },
    { to: '/inventory', icon: Package, label: 'Inventory', roles: ['admin', 'manager'] },
    { to: '/locations', icon: MapPin, label: 'Locations', roles: ['admin', 'manager'] },
    { to: '/replenishment', icon: Bell, label: 'Replenishment', roles: ['admin', 'manager'] },
    { to: '/reports', icon: ChartLine, label: 'Reports', roles: ['admin', 'manager'] },
    { to: '/users', icon: UsersThree, label: 'Users', roles: ['admin'] },
  ];

  const filteredLinks = links.filter(link => link.roles.includes(user?.role));

  return (
    <div className="w-64 bg-white border-r border-[#E4E4E7] flex flex-col" data-testid="sidebar">
      <div className="p-6 border-b border-[#E4E4E7]">
        <h1 className="heading text-2xl font-black text-[#09090B]" data-testid="sidebar-title">
          WMS
        </h1>
        <p className="text-xs text-[#A1A1AA] mt-1">Warehouse Management</p>
      </div>

      <nav className="flex-1 p-4 space-y-1" data-testid="sidebar-nav">
        {filteredLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-150 ${
                isActive
                  ? 'bg-[#FF3B30] text-white'
                  : 'text-[#52525B] hover:bg-[#FAFAFA]'
              }`
            }
            data-testid={`sidebar-link-${link.label.toLowerCase().replace(' ', '-')}`}
          >
            {({ isActive }) => (
              <>
                <link.icon size={20} weight={isActive ? 'fill' : 'regular'} />
                <span>{link.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-[#E4E4E7]">
        <div className="px-3 py-2">
          <p className="text-xs text-[#A1A1AA] uppercase tracking-wide mb-1">Logged in as</p>
          <p className="text-sm font-medium text-[#09090B]" data-testid="sidebar-user-name">{user?.name}</p>
          <p className="text-xs mono text-[#52525B] mt-0.5 capitalize" data-testid="sidebar-user-role">{user?.role}</p>
        </div>
      </div>
    </div>
  );
}
